import React from "react";

/**
 * Render a plain-text string with any [n] citation tokens replaced by
 * clickable anchor links using the provided annexure map.
 * Use this in places where full markdown rendering is overkill (table cells,
 * banner messages, dashboard finding lines).
 */
export default function CitedText({ text, annexure }) {
    if (!text) return null;
    if (!annexure || Object.keys(annexure).length === 0) return <>{text}</>;
    const parts = [];
    const re = /\[(\d+)\]/g;
    let lastIdx = 0;
    let m;
    let key = 0;
    while ((m = re.exec(text)) !== null) {
        if (m.index > lastIdx) parts.push(<React.Fragment key={key++}>{text.slice(lastIdx, m.index)}</React.Fragment>);
        const n = m[1];
        const entry = annexure[n];
        if (entry?.url) {
            parts.push(
                <a
                    key={key++}
                    href={entry.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={entry.title || entry.url}
                    className="text-ciff-magenta hover:text-ciff-magentaDeep underline decoration-ciff-magenta/40 hover:decoration-ciff-magenta font-medium"
                >
                    [{n}]
                </a>
            );
        } else {
            parts.push(<React.Fragment key={key++}>[{n}]</React.Fragment>);
        }
        lastIdx = m.index + m[0].length;
    }
    if (lastIdx < text.length) parts.push(<React.Fragment key={key++}>{text.slice(lastIdx)}</React.Fragment>);
    return <>{parts}</>;
}
